import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "global-dialog" }
const _hoisted_2 = { class: "global-dialog-header" }
const _hoisted_3 = { class: "global-dialog-body" }
const _hoisted_4 = { class: "global-dialog-footer" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      tabindex: "-1",
      class: "overlay",
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", {
        class: "global-dialog-container",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dialog.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dialog.message), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "global-button -only-text",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.dialog.cancelText), 1)
          ]),
          _createElementVNode("button", {
            class: "global-button -bold",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.dialog.confirmText), 1)
          ])
        ])
      ])
    ])
  ]))
}